import { createAsyncThunk } from "@reduxjs/toolkit";

import config from "config/config";
import { getToken } from "js/formatting/getToken";
import moment from "moment/moment";

export const getImage = createAsyncThunk(
  "getImage",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      let options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
          Authorization: `bearer ${getToken()}`,
        },
        body: JSON.stringify({
          gXdpApi: {
            transactionType: {
              sourceNameSpace: "IMAGING",
              targetNameSpace: "GIDP",
              operation: "GET",
              eventName: "GETIMAGE",
            },
            gIdpPayLoad: {
              image: payload,
              addOnProperties: {
                lifesys: {
                  policyHolder: {
                    company: config.COMPANY,
                    clientName: config.CLIENTNAME,
                    system: "Imaging",
                    lifeSysDataset: "I",
                    showLogTimeStamp: "Y",
                  },
                },
              },
            },
            correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
            addOnProperties: {},
          },
        }),
      };

      const response = await fetch(
        config.ODS_API_BASE_URL + "/ce-correspondence/GetImage",
        options
      );

      if (!response.ok) {
        return rejectWithValue(response);
      }

      const data = await response.json();
      if (data?.gXdpApi?.success) {
        return fulfillWithValue(data.gXdpApi.gIdpPayLoad.correspondences[0]);
      } else {
        return rejectWithValue(data?.gXdpApi?.gIdpPayLoad?.errorMessage);
      }
    } catch (error) {
      throw rejectWithValue(error.message);
    }
  }
);
